import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["testersList"]

  addTester() {
    const container = this.testersListTarget
    const div = document.createElement('div')
    div.className = 'flex items-center space-x-2'
    div.innerHTML = `
      <input
        type="text"
        name="antigenic_run[testers][]"
        class="flex-1 rounded-md border-slate-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
        placeholder="Tester name"
      />
      <button type="button" data-action="click->antigenic-run-form#removeTester" class="text-red-600 hover:text-red-800 text-sm font-medium">Remove</button>
    `
    container.appendChild(div)
  }

  removeTester(event) {
    event.target.parentElement.remove()
  }
}
